import React, { useState } from 'react';

import Box from '@amzn/meridian/column';
import Text from '@amzn/meridian/text';
import ConfirmModal from 'src/components/shared/confirmModal/confirmModal';
import { JmrFlowTypes } from 'src/utils/jmrUtils';
import { type LimitationReviewItem } from 'src/utils/restrictionUtils';

import { SectionTitle, SectionWrapper } from '../common';

// **** Types **** //

interface LimitationsReviewProps {
  limitationReviewItems: LimitationReviewItem[];
  jmrFlowType: JmrFlowTypes;
  onConfirm: () => void;
}

// **** Components **** //

/**
 * Default component.
 */
const LimitationsReview = ({ limitationReviewItems, jmrFlowType, onConfirm }: LimitationsReviewProps) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <Box>
      {/* Header */}
      <SectionTitle
        label="Non-Physical Limitations"
        editButtonDisabled={jmrFlowType === JmrFlowTypes.AlternativePlacementRecommended}
        editButtonOnClick={() => setIsModalOpen(true)}
      />

      {/* Task List */}
      {limitationReviewItems.length > 0 ? (
        limitationReviewItems.map((limitation, i) => (
          <Box key={i} spacingInset="none none 300 none">
            <SectionWrapper label={limitation.label} items={limitation.items} />
          </Box>
        ))
      ) : (
        <Text type="b300" color="secondary">
          No limitations selected
        </Text>
      )}

      {/* Modals */}
      <ConfirmModal
        width="419px"
        modalTitle="Leave page"
        modalDescription="Leaving this page will restart your Job Match Results process."
        open={isModalOpen}
        setOpen={() => setIsModalOpen(false)}
        onConfirm={onConfirm}
      />
    </Box>
  );
};

// **** Export **** //

export default LimitationsReview;
